<template>
  <div>
      <el-menu>
        <el-menu-item index="index" @click="selected('0')">{{$t('m.WhatIsFaxchain')}}?</el-menu-item>
      </el-menu>
      <el-menu :default-openeds="['1']">
        <el-submenu index="1">
          <template slot="title">入门</template>
            <el-menu-item index="1-1" @click="selected('1-1')">安装</el-menu-item>
            <el-menu-item index="1-2" @click="selected('1-2')">加入测试网</el-menu-item>
            <el-menu-item index="1-3" @click="selected('1-3')">常用命令示例</el-menu-item>
            <el-menu-item index="1-4" @click="selected('1-4')">安装常见问题</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">开发者</template>
            <el-menu-item index="2-1" @click="selected('2-1')">主网快速入门</el-menu-item>
            <el-menu-item index="2-6" @click="selected('2-6')">测试网升级</el-menu-item>
            <el-menu-item index="2-2" @click="selected('2-2')">基本</el-menu-item>
            <el-menu-item index="2-3" @click="selected('2-3')">工具</el-menu-item>
            <el-menu-item index="2-4" @click="selected('2-4')">部署</el-menu-item>
            <el-menu-item index="2-5" @click="selected('2-5')">FRC20 代币</el-menu-item>
            <el-menu-item index="2-6" @click="selected('2-6')">FRC721</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">委托人</template>
            <el-menu-item index="3-1" @click="selected('3-1')">委托人概述</el-menu-item>
            <el-menu-item index="3-2" @click="selected('3-2')">委托人指南 (CLI)</el-menu-item>
            <el-menu-item index="3-3" @click="selected('3-3')">委托人常见问题</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">验证器</template>
            <el-menu-item index="4-1" @click="selected('4-1')">验证器概述</el-menu-item>
            <el-menu-item index="4-2" @click="selected('4-2')">验证器指南 (CLI)</el-menu-item>
            <el-menu-item index="4-3" @click="selected('4-3')">验证器常见问题</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">概念</template>
            <el-menu-item index="5-1" @click="selected('5-1')">基本概念</el-menu-item>
            <el-menu-item index="5-7" @click="selected('5-7')">分润方案</el-menu-item>
            <el-menu-item index="5-2" @click="selected('5-2')">收费模式</el-menu-item>
            <el-menu-item index="5-3" @click="selected('5-3')">链上治理</el-menu-item>
            <el-menu-item index="5-4" @click="selected('5-4')">匹配系统</el-menu-item>
            <el-menu-item index="5-5" @click="selected('5-5')">哨兵节点</el-menu-item>
            <el-menu-item index="5-6" @click="selected('5-6')">两种地址</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">资源</template>
            <el-menu-item index="6-1" @click="selected('6-1')">创世纪文件</el-menu-item>
            <el-menu-item index="6-2" @click="selected('6-2')">FAX 客户端</el-menu-item>
            <el-menu-item index="6-3" @click="selected('6-3')">服务供应商</el-menu-item>
        </el-submenu>
        <el-menu-item index="7-1" @click="selected('7-1')">API</el-menu-item>
        
      </el-menu>
  </div>
</template>

<script>
export default {
    name: 'SideBar',
    methods: {
        selected(index) {
            this.$emit('selectedIndex',index)
        }
    }

}
</script>

<style lang="sass" scoped>
</style>